import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';

import { EnvironmentService } from '../../core/enviroment/environment.service';
import { Payload, Facs, AutoComplite, Favorite, UpdateFacs } from 'src/app/core/models/facs.model';
import { setDefaultFilterSearchDashboardFac } from 'src/app/shared/functions/DefaultFilterSearchDashboardFac';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';

@Injectable({
  providedIn: 'root'
})
export class FacsService {

  public toggle = this.environmentService.getEnvVar('feature_table') === 'true';

  public uriv3 = this.environmentService.getEnvVar('api_facs_v3');
  public uriv2 = this.environmentService.getEnvVar('api_facs_v2');
  public uriv1 = this.environmentService.getEnvVar('api_facs');


  public dataList = [{
    stage: 0,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 1,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 2,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 3,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 4,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 5,
    page_number: 1,
    page_items: 30
  }];

  public sendList = new Subject<any>();
  public getSideMenu = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private featureToggleService: FeatureToggleService
  ) { }

  public puthFavorite(data: Favorite): Observable<Favorite> {
    return this.http.patch<Favorite>(`${this.uriv1}/favorite/`, data);
  }

  public updateFacs(data: UpdateFacs): Observable<Facs[]> {
    return this.http.patch<Facs[]>(`${this.uriv1}/fac/${data.id}`, data.stage);
  }

  public autoComplete(data: string | number): Observable<AutoComplite []> {
    const filter = {
      or: {
        multi_match: {
          search_value: data,
          match: 'CONTAINS_PHRASE',
          fields: [
            {
              name: 'person.name',
              type: 'Cliente'
            },
            {
              name: 'offered_products.name',
              type: 'Produto'
            },
            {
              name: 'person.email',
              type: 'Email'
            },
            {
              name: 'person.phone',
              type: 'Telefone'
            },
            {
              name: 'fac_number',
              type: 'Número da FAC'
            }
          ]
        }
      }
    };
    return this.http.post<AutoComplite []>(`${this.toggle ? this.uriv2 : this.uriv1}/fac/autocomplete/`, filter);
  }

  public filterv2(
    data: any, index: number, page?: number,
    tag?: any[], pageStage?: any[], isTable?: boolean, order?: any[]): Observable<Payload> {
    const filterSearch = {
      and: {
        multi_match: {
          search_value: data.fields,
          match: 'CONTAINS_PHRASE',
          fields: [
            {
              name: 'person.name',
              type: 'Cliente'
            },
            {
              name: 'offered_products.name',
              type: 'Produto'
            },
            {
              name: 'person.email',
              type: 'Email'
            },
            {
              name: 'person.phone',
              type: 'Telefone'
            },
            {
              name: 'fac_number',
              type: 'Número da FAC'
            }
          ]
        },
        tags: tag,
        filters: [
          {
            field: 'color',
            value: data.color,
            match: 'CONTAINS_PHRASE'
          },
          {
            field: 'is_favorite',
            value: data.is_favorite,
            match: 'PHRASE'
          },
          {
            field: 'temperature.name',
            value: data.temperature,
            match: 'CONTAINS_PHRASE'
          },
          {
            field: 'badges.name',
            value: data.badges.name,
            match: data.badges.flag ? 'CONTAINS_PHRASE' : 'NOT_CONTAINS_PHRASE'
          },
          {
            field: 'archived',
            value: data.archived,
            match: 'PHRASE'
          }
        ],
        ranges: [...data.ranges]
      },
      sorts: order,
      page_items: page,
      page_number: index,
      pages: pageStage.length ? pageStage : this.dataList,
      tabular_view: isTable
    };
    if (!filterSearch.and.tags.length) {
      delete filterSearch.and.tags;
    }
    if (!filterSearch.and.multi_match.search_value) {
      delete filterSearch.and.multi_match;
    }
    filterSearch.and.filters = filterSearch.and.filters.filter(x => x.value !== null);
    if (filterSearch.and.filters.length <= 0) {
      delete filterSearch.and.filters;
    }
    if (data.fields === undefined) {
      delete filterSearch.and.multi_match;
    }
    if (order === undefined || !order.length || order[0].sort === undefined) {
      delete filterSearch.sorts;
    }

    if (this.featureToggleService.isActive('toggle_default_search_dashboard_fac')) {
      const numberMonthsBehind = +this.environmentService.getEnvVar('number_months_behind');
      setDefaultFilterSearchDashboardFac(filterSearch, numberMonthsBehind);
    }
    
    return this.http.post<any>(`${this.toggle ? this.uriv3 : this.uriv2}/dashboard`, filterSearch);
  }

  public setList(data) {
    this.sendList.next(data);
  }

  public getList() {
    return this.sendList.asObservable();
  }

  public setOpen(data: boolean) {
    return this.getSideMenu.next(data);
  }

  public getOpen() {
    return this.getSideMenu.asObservable();
  }

  public getClientMessages(id) {
    return this.http.get<any>(`${this.uriv1}/fac/${id}/chat-messages`);
  }

  public sendClientMessage(id, message) {
    return this.http.post<any>(`${this.uriv1}/fac/${id}/chat-message`, message);
  }

  public postFacPackTransfer(data: any): Observable<any> {
    return this.http.post<any>(`${this.uriv1}/fac/bulk-transfer/`, data);
  }

  public postFacBulkArchive(data: any): Observable<any> {
    return this.http.post<any>(`${this.uriv1}/fac/bulk-archive/`, data);
  }

  public postFacBulkDiscard(data: any): Observable<any> {
    return this.http.post<any>(`${this.uriv1}/fac/bulk-discard/`, data);
  }

}